module.exports = __webpack_public_path__ + "img/96666333-711x800.1c24ca85.jpg";